var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IconGroup"},[_c('img',{staticClass:"IconGroup__icon",attrs:{"src":_vm.icon ? _vm.icon : require('@/assets/user/empty-avatar-dark.svg')}}),_c('span',{staticClass:"text__sr"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }